import { render, staticRenderFns } from "./opportunities.vue?vue&type=template&id=52e59c9a&scoped=true&"
import script from "./opportunities.vue?vue&type=script&lang=js&"
export * from "./opportunities.vue?vue&type=script&lang=js&"
import style0 from "./opportunities.vue?vue&type=style&index=0&id=52e59c9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e59c9a",
  null
  
)

component.options.__file = "opportunities.vue"
export default component.exports